/**
 * @returns {Promise<String>}
 */
export default async function getResolvedPlaylist({ provider, id }) {
    return this.get(`/${provider}/${id}`, { query: { cb: Math.random() } });
}
